<template>
  <div class="app-content content devcontent">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
        <div class="container-fluid">
          <div class="row breadcrumbs-top">
            <div class="col-md-12 content-header-left px-0">
              <h3 class="content-header-title float-left mb-0">
                STC Contact List
              </h3>

              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                      <router-link to="/escalation/stc-contacts">
                        STC Contact List</router-link
                      >
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="modal fade" id="imagemodal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body p-0">
                <div class="view_photo_transaction">
                  <button type="button" class="close imageModalClose" data-dismiss="modal">
                    <x-icon size="1.5x" class="custom-class avatar-icon font-medium-3"></x-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <vue-element-loading :is-full-screen="true" />

        <section id="dashboard-ecommerce" class=" ">
          <div class="card">
            <div class="card-header px-0 common_top_title_searchbgst_dock">
              <div class="container-fluid">
                <div class="row fc_my-05 align-items-center">
                  <div class="col-12 col-sm-auto">
                    <div class="d-flex align-items-center">
                      <div class="avatar bg-light-secondary rounded mr-1">
                        <div class="avatar-content">
                          <i data-feather="layers" class="i_icon_st la-clipboard-list las lab font-medium-3"></i>
                        </div>
                      </div>
                      <h4 class="card-title ml-0 mb-0">STC List</h4>
                    </div>
                  </div>
                  <div class="col-12 col-sm">
                    <div class="d-flex justify-content-end mt-2 mt-sm-0">
                      <button class="btn btn-primary" @click="onCreateFormHandler">Create</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-content">
              <div role="tabpanel" class="tab-pane active" id="report" aria-labelledby="gate_tab" aria-expanded="true">
                <div class="collapse-margin collapse-icon mt-0" id="faq-cancellation-qna">
                  <div class="card border rounded mb-1 mt-0">
                    <div id="faq-cancellation-one" class="" aria-labelledby="cancellationOne"
                      data-parent="#faq-cancellation-qna">
                      <div class="table-responsive mb-0">
                        <table
                          class="table dataTableListing table-hover table-striped project_name_member_text_01 custom_doctable"
                          aria-describedby="mydesc" id="escalation_call_Details">
                          <thead class="header-primary">
                            <tr class="thfirst_dock_performance">
                              <template>
                                <th class="text-left align-middle">
                                  Sr.No
                                </th>
                                <th class="text-left align-middle">
                                  Zone
                                </th>
                                <th class="text-left align-middle">
                                  EDC
                                </th>
                                <th class="text-left align-middle" style="min-width: 220px">
                                  EDC Contact Details
                                </th>
                                <th class="text-left align-middle" style="min-width: 220px">
                                  STC Details
                                </th>
                                <th class="text-left align-middle" style="min-width: 220px">
                                  Network Details
                                </th>
                              </template>
                            </tr>
                          </thead>
                          <tbody>
                            <vue-element-loading spinner="bar-fade-scale" :active="isMasterListLoading" />
                            <template v-for="(data, index) in stc_contact_Details.list">
                              <tr>
                                <td data-column="Sr.No" class="text-left merge_column_detals" style="width:100px;">
                                  {{ index + 1 + stc_contact_Details.currPageNum * stc_contact_Details.pagelimit }}
                                </td>
                                <td data-column="Zone" class="text-left merge_column_detals">
                                  {{ data.zone }}
                                </td>
                                <td data-column="EDC" class="text-left merge_column_detals">
                                  {{ data.edc }}
                                </td>
                                <td data-column="EDC Contact Details" class="text-left merge_column_detals">
                                  <div class="meger_details">
                                    <span class="title_name_text">EDC Contact No :</span>
                                    <span class="title_value_text">{{ data.edc_contact }}</span>
                                  </div>
                                  <div class="meger_details">
                                    <span class="title_name_text"> EDC Head :</span>
                                    <span class="title_value_text">{{ data.edch }}</span>
                                  </div>
                                  <div class="meger_details">
                                    <span class="title_name_text"> EDC Head Contact :</span>
                                    <span class="title_value_text">{{ data.edch_contact }}</span>
                                  </div>
                                </td>
                                <td data-column="STC Details" class="text-left merge_column_detals">
                                  <div class="meger_details">
                                    <span class="title_name_text">STC :</span>
                                    <span class="title_value_text">{{ data.stc }}</span>
                                  </div>
                                  <div class="meger_details">
                                    <span class="title_name_text">STC Manager :</span>
                                    <span class="title_value_text">{{ data.stc_manager }}</span> 
                                  </div>
                                  <div class="meger_details">
                                    <span class="title_name_text"> STC Contact No :</span>
                                    <span class="title_value_text">{{ data.stc_contact }}</span>
                                  </div>

                                </td>
                                <td data-column="Network Details" class="text-left merge_column_detals">
                                  <div class="meger_details">
                                    <span class="title_name_text">Network Manager :</span>
                                    <span class="title_value_text">{{ data.network_manager }}</span> 
                                  </div>
                                  <div class="meger_details">
                                    <span class="title_name_text"> Network Contact :</span>
                                    <span class="title_value_text">{{ data.network_contact }}</span>
                                  </div>
                                </td>

                              </tr>
                            </template>
                            <template v-if="!stc_contact_Details.list.length">
                              <tr>
                                <td colspan="14" style="text-align: center">
                                  No records found
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                      <div class="pageCenter text-center mt-4 pagination_viewallpages">
                        <pagination v-model="stc_contact_Details.page" :records="stc_contact_Details.totalcount"
                          :per-page="stc_contact_Details.pagelimit" @paginate="(e) => handlePageChange(e)" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Pagination from "vue-pagination-2";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Treeselect from "@riophae/vue-treeselect";
import VueElementLoading from "vue-element-loading";
import {
  XCircleIcon,
  FileIcon,
  UploadIcon,
  DownloadIcon,
  EditIcon,
  XIcon,
} from "vue-feather-icons";
import CONSTANT from "../../constants.js";
import { read, utils } from "xlsx";
// import schema from "../../utils/schema";
import common_methods from "../../utils/common_methods";
import searchMasterNameList from "../../utils/searchMasterNameList";

export default {
  name: "stccontactlist",
  mixins: [common_methods, searchMasterNameList],
  components: {
    Treeselect,
    DatePicker,
    VueElementLoading,
    Pagination,
    UploadIcon,
    FileIcon,
    XCircleIcon,
    DownloadIcon,
    EditIcon,
    XIcon,
  },
  data() {
    return {
      isLoading: false,
      isMasterListLoading: false,
      stc_contact_Details: {
        url: "/contacts/getstcdetails",
        list: [],
        totalcount: 0,
        pageCount: 0,
        page: 1,
        pagelimit: CONSTANT.LIMIT,
        currPageNum: 0,
        pageoffset: 1,
      },
    };
  },
  mounted() { },
  created() {
    this.getStcContacts();
  },
  methods: {
    onCreateFormHandler() {
      this.$router.push('/escalation/stcform')
    },
    getStcContacts() {
      this.isMasterListLoading = true;
      let payload = {
        rows: CONSTANT.LIMIT,
        page: this.stc_contact_Details.pageoffset,
      };
      axios({
        method: "POST",
        url: this.stc_contact_Details.url,
        data: payload,
      })
        .then((result) => {
          this.isMasterListLoading = false;
          if (result.data.status) {
            this.stc_contact_Details.list = result.data.data.rows;
            this.stc_contact_Details.totalcount = result.data.data.count;
            this.stc_contact_Details.pageCount = Math.ceil(
              this.stc_contact_Details.totalcount /
              this.stc_contact_Details.pagelimit
            );
            //console.log(this.stc_contact_Details.list)
          } else {
            this.sweetAlertSnackbar(result.data.message, "error");
            stc_contact_Details.totalcount = 0;
            stc_contact_Details.pageCount = 0;
          }
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    handlePageChange(pageNum) {
      this.stc_contact_Details.pageoffset = pageNum;
      this.stc_contact_Details.currPageNum = pageNum - 1;
      this.getStcContacts();
      setTimeout(() => {
        $("html, body").animate({
          scrollTop: $(`#${tab}`).offset().top - 70,
        });
      }, 500);
    },
  },
};
</script>
<style scoped>
.filters,
.filters2 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 8px;
}

.filters button,
.filters2 button {
  background: none;
  border: none;
  font-weight: 500;
  letter-spacing: 0.3px;
  border-radius: 2px;
  padding: 3px 5px !important;
}

.tabs_dockview .active button {
  background: #ff9800;
  color: #fff;
}

.innerphoto_details_doc_04 {
  width: 140px;
  display: flex;
  border-bottom: 1px solid #dbdbdb;
  max-height: 140px;
  min-height: 140px;
  align-items: center;
  margin: 0px auto;
  overflow: hidden;
}
</style>
